<script lang="ts">
	import type { HTMLInputAttributes } from "svelte/elements";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { emailPattern } from "@core/utils/email.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";

	const { ...rest }: HTMLInputAttributes = $props();
	const { tenant } = getGlobalTemplateProps();

	const type = $derived(rest.type ?? "text");
	const customPattern: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, string>> = {
		email: emailPattern,
	};
	const pattern = $derived(rest.pattern ?? customPattern[type]);

	const customValidationMessage: Partial<Record<NonNullable<HTMLInputAttributes["type"]>, LocalizedString>> = {
		email: {
			[Locale.cs]: "E-mailová adresa",
			[Locale.en]: "E-mail address",
		},
		url: {
			[Locale.cs]: "URL adresa (včetně https://)",
			[Locale.en]: "URL address (including https://)",
		},
	};

	function validate({ currentTarget }: Event & { currentTarget: EventTarget & HTMLInputElement }): void {
		currentTarget.setCustomValidity("");

		if (currentTarget.validity.valid) {
			currentTarget.setCustomValidity("");
		} else {
			const customMessage = customValidationMessage[type]?.[tenant.locale];
			if (customMessage) {
				currentTarget.setCustomValidity(customMessage);
			}
		}
	}
</script>

<input
	{...rest}
	class={[
		"min-w-0 rounded border shadow-sm border-transparent [&:user-invalid]:border-fstphlox transition-[outline,text,border] duration-300 focus:border-fstgreen focus:[&:user-invalid]:outline-fstgreen outline-transparent outline-1 outline outline-offset-1 p-3",
		{
			"min-h-[3.125rem]": !["radio", "checkbox"].includes(type),
		},
		rest.class,
	]}
	{pattern}
	oninput={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		validate(event);
		rest.oninput?.(event);
	}}
	oninvalid={(event: Event & { currentTarget: EventTarget & HTMLInputElement }): void => {
		validate(event);
		rest.oninvalid?.(event);
	}}
/>
